(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/build-title.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/build-title.js');
"use strict";


const buildTitle = function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const title = [];
  fragments.sport && title.push(fragments.sport);
  fragments.league && title.push(" - ".concat(fragments.league));
  fragments.teams && title.push(fragments.teams.length ? ", ".concat(fragments.teams.join(' - ')) : '');
  return title.length ? title.join('') : null;
};
if (svs.isServer) {
  module.exports = buildTitle;
} else {
  svs.sportsbook.sbtech_api_impl.utils.buildTitle = buildTitle;
}

 })(window);